import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';
import type { NoonReport } from './types';
import { useNoonReport } from './useData';

const Form: React.FC = () => (
  <GenericFormPage<NoonReport>
    useData={useNoonReport}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
